var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12.5C16.3808 12.5 17.5 13.6192 17.5 15C17.5 16.3808 16.3808 17.5 15 17.5C13.9125 17.5 12.9975 16.8017 12.6533 15.8333H2.5V14.1667H12.6533C12.9975 13.1983 13.9125 12.5 15 12.5ZM5 7.5C6.0875 7.5 7.0025 8.1975 7.34667 9.16667H17.5V10.8333H7.34667C7.0025 11.8025 6.0875 12.5 5 12.5C3.61917 12.5 2.5 11.3808 2.5 10C2.5 8.61917 3.61917 7.5 5 7.5ZM15 2.5C16.3808 2.5 17.5 3.61917 17.5 5C17.5 6.38083 16.3808 7.5 15 7.5C13.9125 7.5 12.9975 6.8025 12.6533 5.83333H2.5V4.16667H12.6533C12.9975 3.1975 13.9125 2.5 15 2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.8d0931e5b4b46bf7e10d8e95f835bdad.svg";
export { ForwardRef as ReactComponent };